<template>
    <li>
        <div class="title"><span>掛け率</span></div>
        <div class="detail _range">
            <div>
                <input type="number" class="edit-pen" value="2.5"><span>%</span>
            </div>
            <div>
                <input type="number" class="edit-pen" value="5"><span>%</span>
            </div>
        </div>
    </li>
</template>